/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { useLocation } from "react-router-dom";
import { useCookies } from "react-cookie";

import localizationConf from "../../config/localizationConf";
import authProfileState from "../../states/authProfileState";
import menuInfoState from "../../states/menuInfoState";
import topMenuSelectionState from "../../states/topMenuSelectionState";
import subMenuSelectionState from "../../states/subMenuSelectionState";

import makeSelectionByPath from "../../lib/utils/makeSelectionByPath";

import LoginRouter from "./LoginRouter";

import AppLayout from "../layout/AppLayout";
import TopPaneLayout from "../layout/TopPaneLayout";
import SidePaneLayout from "../layout/SidePaneLayout";
import MainPaneLayout from "../layout/MainPaneLayout";

import ComponentRouter from "./ComponentRouter";

import TopMenu from "../menu/functional/TopMenu";
import SubMenu from "../menu/functional/SubMenu";
import NewWindowRouter from "./newWindowRouter";
import NewWindowLayout from "../layout/newWindowLayout";

import { useTranslation } from "react-i18next";

function MesApp() {
    const authProfile = useRecoilValue(authProfileState);
    const menuInfo = useRecoilValue(menuInfoState);
    const setSubMenuSelection = useSetRecoilState(subMenuSelectionState);
    const [topMenuSelection, setTopMenuSelection] = useRecoilState(topMenuSelectionState);

    let location = useLocation();

    const { i18n } = useTranslation();

    const [, setCookie] = useCookies([localizationConf.cookieName]);

    useEffect(() => {
        if (!i18n.language) {
            i18n.changeLanguage("kr");
            setCookie(localizationConf.cookieName, "kr", { path: "/" });
        } else {
            setCookie(localizationConf.cookieName, i18n.language, { path: "/" });
        }

        let selection = makeSelectionByPath(menuInfo, location.pathname);

        setTopMenuSelection(selection.top);
        setSubMenuSelection(selection.sub);
    }, [menuInfo, location]);

    return (
        <>
            {location && location.pathname.split("/")[1] === "newWindow" ? (
                <NewWindowLayout>
                    <NewWindowRouter />
                </NewWindowLayout>
            ) : authProfile && authProfile.loggedIn ? (
                location && location.pathname.split("/")[2] === "dashboard" ? (
                    <ComponentRouter />
                ) : (
                    <AppLayout>
                        <TopPaneLayout className="topPaneLayout">
                            <SubMenu topMenuId={topMenuSelection} menuItems={menuInfo.subMenuItems} />
                        </TopPaneLayout>
                        <SidePaneLayout className="sidePaneLayout">
                            <TopMenu menuItems={menuInfo.topMenuItems} />
                        </SidePaneLayout>
                        <MainPaneLayout className="mainPaneLayout">
                            <ComponentRouter />
                        </MainPaneLayout>
                    </AppLayout>
                )
            ) : (
                <LoginRouter />
            )}
        </>
    );
}

export default MesApp;
